import React, { useContext, useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import {
	Typography,
	Button,
	Paper,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Grid,
	TextField,
	InputAdornment,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListItemSecondaryAction,
	IconButton,
	Tooltip,
	Divider
} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import { NavLink } from "react-router-dom";

import InfoTooltip from "../general/InfoTooltip";
import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";

import SaveIcon from "@material-ui/icons/Save";
import GetAppIcon from "@material-ui/icons/GetApp";
import SettingsInputCompositeIcon from "@material-ui/icons/SettingsInputComposite";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DescriptionIcon from '@material-ui/icons/Description';
import DeleteIcon from '@material-ui/icons/Delete';

import { DropzoneArea } from "material-ui-dropzone";

import { TOP_CONDITION_SETTINGS, TOP_AGENT_NOTE_SETTINGS, canViewAgentNotes } from "../credits/topConditionsConfig";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 1000,
		marginLeft: "auto",
		marginRight: "auto"
	},
	actionButtons: theme.actionButtons,
	settingsGroup: {
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2)
	},
	accordionGroup: {
		marginBottom: theme.spacing(2),
		borderRadius: theme.shape.borderRadius,
		overflow: "hidden",
		"&:before": {
			display: "none",
		},
		"&.Mui-expanded": {
			margin: `0 0 ${theme.spacing(2)}px 0`,
		},
	},
	dropzone: {
		padding: 20,
		height: 200,
		minHeight: 200,
		fontFamily: "Roboto, 'Segoe UI', 'Helvetica Neue', Arial",
		fontSize: 13,
		textTransform: "uppercase",
		letterSpacing: 1,
		"& p": {
			fontSize: 13,
		},
	},
}));

export default function Settings(props) {
	const theme = useTheme();
	const classes = useStyles();
	const [settings, setSettings] = useState(
		{
			...Object.fromEntries(TOP_AGENT_NOTE_SETTINGS.map(({ key, type }) => [key, { key, setting_type: type, value: "" }])),
			excel_template: {
				setting_type: "file",
				key: "excel_template",
			},
			excel_template_konsum: {
				setting_type: "file",
				key: "excel_template_konsum",
			},
			signosign_user: {
				setting_type: "string",
				key: "signosign_user",
			},
			signosign_password: {
				setting_type: "string",
				key: "signosign_password",
			},
			fixzins_03: {
				setting_type: "float",
				key: "fixzins_03",
			},
			fixzins_05: {
				setting_type: "float",
				key: "fixzins_05",
			},
			fixzins_06: {
				setting_type: "float",
				key: "fixzins_06",
			},
			fixzins_10: {
				setting_type: "float",
				key: "fixzins_10",
			},
			fixzins_15: {
				setting_type: "float",
				key: "fixzins_15",
			},
			fixzins_20: {
				setting_type: "float",
				key: "fixzins_20",
			},
			fixzins_25: {
				setting_type: "float",
				key: "fixzins_25",
			},
			varzins3m: {
				setting_type: "float",
				key: "varzins3m",
			},
			zins_comment: {
				setting_type: "string",
				key: "zins_comment",
			},
			signature_template_1: {
				setting_type: "file",
				key: "signature_template_1",
			},
			signature_template_2: {
				setting_type: "file",
				key: "signature_template_2",
			},
			signature_template_3: {
				setting_type: "file",
				key: "signature_template_3",
			},
			signature_template_4: {
				setting_type: "file",
				key: "signature_template_4",
			},
			signature_template_5: {
				setting_type: "file",
				key: "signature_template_5",
			},
			signature_template_6: {
				setting_type: "file",
				key: "signature_template_6",
			},
			signature_template_7: {
				setting_type: "file",
				key: "signature_template_7",
			},
			signature_template_8: {
				setting_type: "file",
				key: "signature_template_8",
			},
			signature_template_9: {
				setting_type: "file",
				key: "signature_template_9",
			},
			signature_template_10: {
				setting_type: "file",
				key: "signature_template_10",
			},
			document_info_1: {
				setting_type: "file",
				key: "document_info_1",
			},
			document_info_2: {
				setting_type: "file",
				key: "document_info_2",
			},
			document_info_3: {
				setting_type: "file",
				key: "document_info_3",
			},
			document_info_4: {
				setting_type: "file",
				key: "document_info_4",
			},
			document_info_5: {
				setting_type: "file",
				key: "document_info_5",
			},
			document_info_6: {
				setting_type: "file",
				key: "document_info_6",
			},
			document_info_7: {
				setting_type: "file",
				key: "document_info_7",
			},
			document_info_8: {
				setting_type: "file",
				key: "document_info_8",
			},
			document_info_9: {
				setting_type: "file",
				key: "document_info_9",
			},
			document_info_10: {
				setting_type: "file",
				key: "document_info_10",
			},
			document_info_11: {
				setting_type: "file",
				key: "document_info_11",
			},
			document_info_12: {
				setting_type: "file",
				key: "document_info_12",
			},
			document_info_13: {
				setting_type: "file",
				key: "document_info_13",
			},
			document_info_14: {
				setting_type: "file",
				key: "document_info_14",
			},
			document_info_15: {
				setting_type: "file",
				key: "document_info_15",
			},
			document_info_16: {
				setting_type: "file",
				key: "document_info_16",
			},
			document_info_17: {
				setting_type: "file",
				key: "document_info_17",
			},
			document_info_18: {
				setting_type: "file",
				key: "document_info_18",
			},
			document_info_19: {
				setting_type: "file",
				key: "document_info_19",
			},
			document_info_20: {
				setting_type: "file",
				key: "document_info_20",
			},
			info_link_url_1: {
				setting_type: "string",
				key: "info_link_url_1",
			},
			info_link_description_1: {
				setting_type: "string",
				key: "info_link_description_1",
			},
			info_link_url_2: {
				setting_type: "string",
				key: "info_link_url_2",
			},
			info_link_description_2: {
				setting_type: "string",
				key: "info_link_description_2",
			},
			info_link_url_3: {
				setting_type: "string",
				key: "info_link_url_3",
			},
			info_link_description_3: {
				setting_type: "string",
				key: "info_link_description_3",
			},
			info_link_url_4: {
				setting_type: "string",
				key: "info_link_url_4",
			},
			info_link_description_4: {
				setting_type: "string",
				key: "info_link_description_4",
			},
			info_link_url_5: {
				setting_type: "string",
				key: "info_link_url_5",
			},
			info_link_description_5: {
				setting_type: "string",
				key: "info_link_description_5",
			},
			info_link_url_6: {
				setting_type: "string",
				key: "info_link_url_6",
			},
			info_link_description_6: {
				setting_type: "string",
				key: "info_link_description_6",
			},
			info_link_url_7: {
				setting_type: "string",
				key: "info_link_url_7",
			},
			info_link_description_7: {
				setting_type: "string",
				key: "info_link_description_7",
			},
			info_link_url_8: {
				setting_type: "string",
				key: "info_link_url_8",
			},
			info_link_description_8: {
				setting_type: "string",
				key: "info_link_description_8",
			},
			info_link_url_9: {
				setting_type: "string",
				key: "info_link_url_9",
			},
			info_link_description_9: {
				setting_type: "string",
				key: "info_link_description_9",
			},
			info_link_url_10: {
				setting_type: "string",
				key: "info_link_url_10",
			},
			info_link_description_10: {
				setting_type: "string",
				key: "info_link_description_10",
				},
			liegenschaft_checklist: {
				setting_type: "file",
				key: "liegenschaft_checklist",
			},
			bankaustria_api_key: {
				setting_type: "string",
				key: "bankaustria_api_key",
			},
		}
	);
	const pageContext = useContext(PageContext);
	const userContext = useContext(UserContext);
	const [currentEditIndex, setCurrentEditIndex] = useState(1);
	const [visibleLinkIndexes, setVisibleLinkIndexes] = useState([1]);
	const [newLinkUrl, setNewLinkUrl] = useState("");
	const [newLinkDescription, setNewLinkDescription] = useState("");

	useEffect(() => {
		Object.keys(settings).forEach((key) => {
			if (!TOP_AGENT_NOTE_SETTINGS.some((setting) => setting.key === key) || canViewAgentNotes(userContext.user.role)) {
				getSetting(settings[key]);
			}
		})
	}, []);



	const getSetting = (setting) => {
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/${setting.setting_type}/${setting.key}`,
			method: 'get',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then(({ data }) => {
				setSettings(settings => {
					return { ...settings, [setting.key]: data };
				})
			})
			.catch((err) => {
				if (err.response && err.response.data && err.response.data.message)
					pageContext.setErrorMessage(err.response.data.message);
				else
					pageContext.setErrorMessage("Die Einstellung konnte nicht geladen werden!");
			});
	}


	const saveSetting = (key) => {
		const setting = settings[key];
		setSettings(current => ({ ...current, [setting.key]: { ...current[setting.key], status: "saving" } }))
		const value_key = setting.setting_type == "string" || setting.setting_type == "file"
			? "value"
			: setting.setting_type == "boolean"
				? "value_boolean"
				: "value_numeric";

		const value = setting.setting_type === "float"
			? setting[value_key] === ""
				? null
				: Number(parseFloat(setting[value_key]).toFixed(3))
			: setting[value_key];

		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/${key}`,
			data: {
				[value_key]: value
			},
			method: 'put',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				setSettings(current => ({ ...current, [setting.key]: { ...current[setting.key], status: "" } }))
				pageContext.setInfoMessage("Einstellung wurde gespeichert");
			})
			.catch((err) => {
				console.log(err);
				setSettings(current => ({ ...current, [setting.key]: { ...current[setting.key], status: "" } }))
				pageContext.setErrorMessage("Einstellung konnte nicht gespeichert werden!");
			});
	}

	const checkChannel = (channel_shortname) => {
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/checkchannel/${channel_shortname}`,
			method: 'get',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				if (res.data.success && res.data.message)
					pageContext.setInfoMessage(res.data.message);
				else if (res.data.success)
					pageContext.setInfoMessage(res.data.message);
				else
					pageContext.setErrorMessage(res.data.message);
			})
			.catch((err) => {
				console.log(err);
				pageContext.setErrorMessage("Die Verbindung konnte nicht hergestellt werden!");
			});
	}

	const checkSignatureCredentials = () => {
		const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/signatures/checkcredentials`,
			method: 'get',
			headers: userContext.getRequestAuthHeader()
		};
		axios(options)
			.then((res) => {
				if (res.data.success && res.data.message)
					pageContext.setInfoMessage(res.data.message);
				else if (res.data.success)
					pageContext.setInfoMessage(res.data.message);
				else
					pageContext.setErrorMessage(res.data.message);
			})
			.catch((err) => {
				console.log(err);
				pageContext.setErrorMessage("Die Verbindung konnte nicht hergestellt werden!");
			});
	}

	const uploadFile = (setting, file, action = null) => {
		const formData = new FormData();
		formData.append("file", file);
		formData.append("setting_key", setting.key);

		const headers = userContext.getRequestAuthHeader(false);

		axios.post(
			`${process.env.REACT_APP_API_SERVICE_URL}/settings/fileuploads`,
			formData, {
			headers: headers
		})
			.then(({ data }) => {
				getSetting(setting);
				pageContext.setInfoMessage(data.message);
			})
			.catch((err) => {
				pageContext.setErrorMessage("Die Datei konnte nicht gespeichert werden!");
			});
	};


	const deleteFile = (setting) => {
		pageContext.setConfirmDialog({
			open: true,
			title: "Wirklich löschen?",
			message:
				"Bist du dir sicher, dass du die Datei " +
				(setting.value) +
				" löschen möchtest?",
			handleYes: () => {
				pageContext.setConfirmDialog({
					open: false,
				});
				const options = {
					url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/fileuploads/${setting.key}`,
					method: 'delete',
					headers: userContext.getRequestAuthHeader()
				};
				axios(options)
					.then((res) => {
						getSetting(setting);
						pageContext.setInfoMessage("Die Datei wurde gelöscht");
					})
					.catch((err) => {
						console.log(err);
						pageContext.setErrorMessage("Die Datei konnte nicht gelöscht werden!");
					});
			},
			handleNo: () => {
				pageContext.setConfirmDialog({
					open: false,
				});
			},
		});
	};

	const moveItem = (list, sourceIndex, destinationIndex) => {
		const result = Array.from(list);
		const [removed] = result.splice(sourceIndex, 1);
		result.splice(destinationIndex, 0, removed);
		return result;
	};

	const handleSort = (result, list, applySortedList) => {
		if (!result.destination) return;

		const sortedList = moveItem(
			list,
			result.source.index,
			result.destination.index
		);

		applySortedList(sortedList);
	};

	const saveSettingsByKeys = (keys) => {
		keys.forEach((key) => {
			saveSetting(key);
		});
	};

	const getDocumentInfoKeys = () => {
		return Object.keys(settings).filter((key) => key.startsWith("document_info_"));
		};

		const getFilledDocumentInfoKeys = () => {
		return getDocumentInfoKeys().filter((key) => settings[key]?.value);
		};

		const applySortedDocumentInfoKeys = (sortedKeys) => {
		const filledKeys = getFilledDocumentInfoKeys();
		const updatedSettings = { ...settings };

		filledKeys.forEach((key, index) => {
			updatedSettings[key] = {
			...updatedSettings[key],
			value: settings[sortedKeys[index]]?.value || "",
			};
		});

		setSettings(updatedSettings);
	};

	// const saveAllDocumentInfoFiles = () => {
	// 	saveSettingsByKeys(getDocumentInfoKeys());
	// };
	const saveAllDocumentInfoFiles = () => {
		Object.keys(settings)
			.filter((key) => key.startsWith("document_info_"))
			.forEach((key) => saveSetting(key));
	};

	const getInfoLinkIndexes = () => {
		return Array.from({ length: 10 }, (_, index) => index + 1);
	};

	const getFilledInfoLinkIndexes = () => {
		return getInfoLinkIndexes().filter((index) => {
			const urlKey = `info_link_url_${index}`;
			const descriptionKey = `info_link_description_${index}`;
			return settings[urlKey]?.value || settings[descriptionKey]?.value;
		});
	};

	const applySortedInfoLinkIndexes = (sortedIndexes) => {
		const filledIndexes = getFilledInfoLinkIndexes();
		const updatedSettings = { ...settings };

		filledIndexes.forEach((originalIndex, newPosition) => {
			const newIndex = sortedIndexes[newPosition];
			const urlKey = `info_link_url_${originalIndex}`;
			const descriptionKey = `info_link_description_${originalIndex}`;
			const newUrlKey = `info_link_url_${newIndex}`;
			const newDescriptionKey = `info_link_description_${newIndex}`;

			updatedSettings[newUrlKey] = {
				...updatedSettings[newUrlKey],
				value: settings[urlKey]?.value || "",
			};
			updatedSettings[newDescriptionKey] = {
				...updatedSettings[newDescriptionKey],
				value: settings[descriptionKey]?.value || "",
			};
		});

		setSettings(updatedSettings);
	};

	const saveAllInfoLinks = () => {
		getInfoLinkIndexes().forEach((index) => {
			saveSetting(`info_link_url_${index}`);
			saveSetting(`info_link_description_${index}`);
		});
	};

	const renderSignatureTemplateSettings = () => {
		const filledSettingKeys = Object.keys(settings).filter(
			key => key.startsWith("signature_template_") && settings[key].value
		);
		// console.log("filledSettingKeys", filledSettingKeys);
		const freeSettingKeys = Object.keys(settings).filter(
			key => key.startsWith("signature_template_") && !settings[key].value
		);
		return <Grid item xs={12}>
			<Typography>
				Lade die Standard PDF Vorlagen hier hoch, die dann von den Kreditnehmern unterschrieben werden können. Du kannst auch zu jeder Finanzierung noch eigene Dokumente hinzufügen.
				<br />Folgende Platzhalter kannst du in die Dokumente einfügen, diese werden dann automatisch ersetzt.
			</Typography>
			<ul>
				<li><strong>[NAME]</strong>... fügt den Vor- und Nachnamen des aktuellen Kreditnehmers ein.</li>
				<li><strong>[NAME KN1], [NAME KN2]</strong>... fügt den Namen eines bestimmten Kreditnehmers ein.</li>
				<li><strong>[NAMEN]</strong>... fügt die Namen aller Kreditnehmer ein.</li>
				<li><strong>[NAME BERATER]</strong>... fügt deinen Namen ein.</li>
				<li><strong>[ALLE BERATER]</strong>... fügt deinen Namen sowie die Geschäftsführer ein.</li>
				<li><strong>[ADRESSE]</strong>... fügt die Adresse des aktuellen Kreditnehmers ein.</li>
				<li><strong>[ADRESSE KN1], [ADRESSE KN2]</strong>... fügt die Adresse eines bestimmten Kreditnehmers ein.</li>
				<li><strong>[DATUM]</strong>... fügt das aktuelle Datum ein.</li>
			</ul>
			<br /><br />

			<Grid container spacing={2}>
				<Grid item xs={12} md={6}>
					{filledSettingKeys.length > 0 ?
						<List>
							<Divider />
							{filledSettingKeys.map(key =>
								<div key={key}>
									<ListItem>
										<ListItemIcon>
											<DescriptionIcon />
										</ListItemIcon>
										<ListItemText primary={settings[key].value} />
										<ListItemSecondaryAction>
											<Tooltip title="Download">
												<IconButton
													edge="end"
													aria-label="download"
													download target="_blank"
													href={`${process.env.REACT_APP_API_SERVICE_URL}/settings/fileuploads/${key}/${settings[key].value}?token=${userContext.accessToken}`}
												>
													<GetAppIcon />
												</IconButton>
											</Tooltip>
											<Tooltip title="Datei löschen">
												<IconButton
													edge="end"
													aria-label="löschen"
													onClick={() => {
														deleteFile(settings[key])
													}}
												>
													<DeleteIcon />
												</IconButton>
											</Tooltip>
										</ListItemSecondaryAction>
									</ListItem>
									<Divider />
								</div>
							)}
						</List>
						: <Typography>Lade deine erste Vorlage hoch...</Typography>
					}
				</Grid>
				{freeSettingKeys.length > 0 ?
					<Grid item xs={12} md={6} lg={3}>
						<DropzoneArea
							dropzoneClass={classes.dropzone}
							onDrop={(newFiles) => {
								if (Array.isArray(newFiles)) uploadFile(settings[freeSettingKeys[0]], newFiles[0]);
								else uploadFile(settings[freeSettingKeys[0]], newFiles);
							}}
							acceptedFiles={[
								"application/pdf",
							]}
							filesLimit={1}
							maxFileSize={20000000}
							showPreviewsInDropzone={false}
							showPreviews={false}
							useChipsForPreview={false}
							showFileNamesInPreview={false}
							showFileNames={false}
							dropzoneText={"Datei hier ablegen oder zum Auswählen klicken."}
							getFileLimitExceedMessage={(filesLimit) => {
								if (filesLimit === 1)
									return "Bitte lade hier nur eine Datei hoch.";

								return "Bitte lade maximal " + filesLimit + " Dateien hoch.";
							}}
							getFileAddedMessage={(fileName) => {
								return "Datei " + fileName + " wird geladen.";
							}}
							getFileRemovedMessage={(fileName) => {
								return "Datei " + fileName + " entfernt.";
							}}
							getDropRejectMessage={(
								rejectedFile,
								acceptedFiles,
								maxFileSize
							) => {
								var message =
									"Die Datei " +
									rejectedFile.name +
									" kann nicht verwendet werden. ";

								if (!acceptedFiles.includes(rejectedFile.type)) {
									message += "Es sind nur PDF Dateien möglich.";
								}

								if (rejectedFile.size > maxFileSize) {
									message +=
										"Die Datei ist zu groß. Es sind maximal  " +
										convertBytesToMbsOrKbs(maxFileSize) +
										" möglich.";
								}

								return message;
							}}
						/>
					</Grid>
					:
					<Grid item xs={6} md={6}>
						<Alert severity="info">Es können maximal 10 Dateien hochgeladen werden.</Alert>
					</Grid>
				}
			</Grid>

		</Grid>
	}

	const renderDocumentInfoSettings = () => {
		const filledSettingKeys = Object.keys(settings).filter(
			key => key.startsWith("document_info_") && settings[key].value
		);

		const freeSettingKeys = Object.keys(settings).filter(
			key => key.startsWith("document_info_") && !settings[key].value
		);

		return (
			<Grid item xs={12}>
			<Typography>
				Hier können zusätzliche Info-Dokumente (Word, Excel, PDF) für das Team abgelegt werden.
				Diese werden im Infobereich zum Download zu Verfügung gestellt.
			</Typography>
			<br />

			<Grid container spacing={2}>
				<Grid item xs={12} md={8}>
				{filledSettingKeys.length > 0 ? (
					<>
					<DragDropContext
						onDragEnd={(result) => {
						handleSort(
							result,
							filledSettingKeys,
							applySortedDocumentInfoKeys
						);
						}}
					>
						<Droppable droppableId="document-info-list">
						{(provided) => (
							<List
							dense
							ref={provided.innerRef}
							{...provided.droppableProps}
							>
							<Divider />

							{filledSettingKeys.map((key, index) => (
								<Draggable
								key={key}
								draggableId={key}
								index={index}
								>
								{(provided) => (
									<div
									ref={provided.innerRef}
									{...provided.draggableProps}
									>
									<ListItem dense>
										<ListItemIcon {...provided.dragHandleProps}>
										<DescriptionIcon />
										</ListItemIcon>

										<ListItemText primary={settings[key].value} />

										<ListItemSecondaryAction>
										<Tooltip title="Download">
											<IconButton
											edge="end"
											aria-label="download"
											download
											target="_blank"
											href={`${process.env.REACT_APP_API_SERVICE_URL}/settings/fileuploads/${key}/${settings[key].value}?token=${userContext.accessToken}`}
											>
											<GetAppIcon />
											</IconButton>
										</Tooltip>

										<Tooltip title="Datei löschen">
											<IconButton
											edge="end"
											aria-label="löschen"
											onClick={() => {
												deleteFile(settings[key]);
											}}
											>
											<DeleteIcon />
											</IconButton>
										</Tooltip>
										</ListItemSecondaryAction>
									</ListItem>

									<Divider />
									</div>
								)}
								</Draggable>
							))}

							{provided.placeholder}
							</List>
						)}
						</Droppable>
					</DragDropContext>

					<br />

					<Button
						variant="contained"
						color="primary"
						size="small"
						startIcon={<SaveIcon />}
						onClick={saveAllDocumentInfoFiles}
					>
						Reihenfolge speichern
					</Button>
					</>
				) : (
					<Typography>Lade dein erstes Dokument hoch...</Typography>
				)}
				</Grid>

				{freeSettingKeys.length > 0 ? (
				<Grid item xs={12} md={4}>
					<DropzoneArea
					dropzoneClass={classes.dropzone}
					onDrop={(newFiles) => {
						if (Array.isArray(newFiles)) {
						uploadFile(settings[freeSettingKeys[0]], newFiles[0]);
						} else {
						uploadFile(settings[freeSettingKeys[0]], newFiles);
						}
					}}
					acceptedFiles={[
						"application/pdf",
						"application/msword",
						"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
						"application/vnd.ms-excel",
					]}
					filesLimit={1}
					maxFileSize={20000000}
					showPreviewsInDropzone={false}
					showPreviews={false}
					useChipsForPreview={false}
					showFileNamesInPreview={false}
					showFileNames={false}
					dropzoneText={"Datei hier ablegen oder zum Auswählen klicken."}
					getFileLimitExceedMessage={(filesLimit) => {
						if (filesLimit === 1) {
						return "Bitte lade hier nur eine Datei hoch.";
						}

						return "Bitte lade maximal " + filesLimit + " Dateien hoch.";
					}}
					getFileAddedMessage={(fileName) => {
						return "Datei " + fileName + " wird geladen.";
					}}
					getFileRemovedMessage={(fileName) => {
						return "Datei " + fileName + " entfernt.";
					}}
					getDropRejectMessage={(rejectedFile, acceptedFiles, maxFileSize) => {
						let message =
						"Die Datei " +
						rejectedFile.name +
						" kann nicht verwendet werden. ";

						if (!acceptedFiles.includes(rejectedFile.type)) {
						message += "Es sind nur Word-, Excel- oder PDF-Dateien möglich.";
						}

						if (rejectedFile.size > maxFileSize) {
						message +=
							"Die Datei ist zu groß. Es sind maximal  " +
							convertBytesToMbsOrKbs(maxFileSize) +
							" möglich.";
						}

						return message;
					}}
					/>
				</Grid>
				) : (
				<Grid item xs={6} md={6}>
					<Alert severity="info">
					Es können maximal 10 Dateien hochgeladen werden.
					</Alert>
				</Grid>
				)}
			</Grid>
			</Grid>
		);
	};
	
	const formatTopRateValue = (value) => {
		if (value === "" || value === null || value === undefined) {
			return "";
		}

		const parsedValue = parseFloat(value);
		if (Number.isNaN(parsedValue)) {
			return "";
		}

		return parsedValue.toFixed(3);
	}

	const renderAgentNoteField = (key, label) => (
		<TextField
			fullWidth multiline margin="dense"
			id={key} name={key} label={label}
			value={settings[key]?.value || ""}
			onChange={(e) => {
				const value = e.target.value;
				setSettings(current => ({ ...current, [key]: { ...current[key], value } }));
			}}
			disabled={settings[key]?.status === "saving"}
		/>
	);

	const renderTopRateField = (key, label, gridProps = { xs: 12, sm: 6, md: 4 }) => {
		const setting = settings[key];
		return <Grid item {...gridProps} key={key}>
			<TextField
				fullWidth
				type="number"
				name={key}
				label={label}
				value={setting.value_numeric ?? ""}
				onChange={(e) => {
					setSettings({
						...settings,
						[e.target.name]: {
							...settings[e.target.name],
							value_numeric: e.target.value,
						}
					})
				}}
				onBlur={(e) => {
					setSettings({
						...settings,
						[e.target.name]: {
							...settings[e.target.name],
							value_numeric: formatTopRateValue(e.target.value),
						}
					})
				}}
				inputProps={{ step: "0.001" }}
				InputProps={{
					endAdornment: <InputAdornment position="end">%</InputAdornment>,
				}}
				disabled={setting.status === "saving"}
			/>
			{canViewAgentNotes(userContext.user.role) && renderAgentNoteField(`${key}_agent_note`, "Hinweis für Agenten")}
		</Grid>
	}

	const topRateFieldSettings = TOP_CONDITION_SETTINGS.filter((setting) => setting.type === "float");
	const topRateSettingKeys = [...TOP_CONDITION_SETTINGS, ...(canViewAgentNotes(userContext.user.role) ? TOP_AGENT_NOTE_SETTINGS : [])].map((setting) => setting.key);

	const renderInfoLinksSettings = () => {
		const maxLinks = 10;
		const filledLinkIndexes = getFilledInfoLinkIndexes();

		const getNextFreeIndex = () => {
			return getInfoLinkIndexes().find((index) => {
				return (
					!settings[`info_link_url_${index}`]?.value &&
					!settings[`info_link_description_${index}`]?.value
				);
			});
		};

		const normalizeUrl = (url) => {
			const trimmed = url.trim();

			if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
				return trimmed;
			}

			return `https://${trimmed}`;
		};

		const isValidUrl = (url) => {
			try {
				const parsedUrl = new URL(normalizeUrl(url));
				return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
			} catch {
				return false;
			}
		};

		const addLink = () => {
			if (!newLinkUrl.trim()) {
				pageContext.setErrorMessage("Bitte eine URL eingeben.");
				return;
			}

			if (!isValidUrl(newLinkUrl)) {
				pageContext.setErrorMessage("Bitte eine gültige URL eingeben.");
				return;
			}

			const nextFreeIndex = getNextFreeIndex();

			if (!nextFreeIndex) {
				pageContext.setErrorMessage("Es können maximal 10 Links hinzugefügt werden.");
				return;
			}

			const urlKey = `info_link_url_${nextFreeIndex}`;
			const descriptionKey = `info_link_description_${nextFreeIndex}`;

			const normalizedUrl = normalizeUrl(newLinkUrl);
			const description = newLinkDescription.trim();

			setSettings({
				...settings,
				[urlKey]: {
					...settings[urlKey],
					value: normalizedUrl,
				},
				[descriptionKey]: {
					...settings[descriptionKey],
					value: description,
				},
			});

			setNewLinkUrl("");
			setNewLinkDescription("");


			axios({
				url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/${urlKey}`,
				data: { value: normalizedUrl },
				method: 'put',
				headers: userContext.getRequestAuthHeader()
			}).catch((err) => {
				pageContext.setErrorMessage("Fehler beim Speichern der URL.");
			});

			axios({
				url: `${process.env.REACT_APP_API_SERVICE_URL}/settings/${descriptionKey}`,
				data: { value: description },
				method: 'put',
				headers: userContext.getRequestAuthHeader()
			}).catch((err) => {
				pageContext.setErrorMessage("Fehler beim Speichern der Beschreibung.");
			});

			pageContext.setInfoMessage("Link wurde hinzugefügt und gespeichert");
		};

		const deleteLink = (index) => {
			const urlKey = `info_link_url_${index}`;
			const descriptionKey = `info_link_description_${index}`;

			setSettings({
				...settings,
				[urlKey]: {
					...settings[urlKey],
					value: "",
				},
				[descriptionKey]: {
					...settings[descriptionKey],
					value: "",
				},
			});
		};

		return (
			<Grid item xs={12}>
				<Typography>
					Hier können Links hinterlegt werden, die im Infobereich der Finanzierungen angezeigt werden.
				</Typography>

				<br />

				<Grid container spacing={2}>
					<Grid item xs={12} md={5}>
						<TextField
							fullWidth
							label="URL"
							value={newLinkUrl}
							onChange={(e) => setNewLinkUrl(e.target.value)}
						/>
					</Grid>

					<Grid item xs={12} md={5}>
						<TextField
							fullWidth
							label="Beschreibung"
							value={newLinkDescription}
							onChange={(e) => setNewLinkDescription(e.target.value)}
						/>
					</Grid>

					<Grid item xs={12}>
						<Button
							variant="outlined"
							color="primary"
							size="small"
							onClick={addLink}
							disabled={filledLinkIndexes.length >= maxLinks}
						>
							Link hinzufügen
						</Button>
					</Grid>

					<Grid item xs={12}>
						{filledLinkIndexes.length > 0 ? (
							<>
								<DragDropContext
									onDragEnd={(result) => {
										handleSort(
											result,
											filledLinkIndexes,
											applySortedInfoLinkIndexes
										);
									}}
								>
									<Droppable droppableId="info-links-list">
										{(provided) => (
											<List
												dense
												ref={provided.innerRef}
												{...provided.droppableProps}
											>
												<Divider />

												{filledLinkIndexes.map((index, listIndex) => (
													<Draggable
														key={`link-${index}`}
														draggableId={`link-${index}`}
														index={listIndex}
													>
														{(provided) => (
															<div
																ref={provided.innerRef}
																{...provided.draggableProps}
															>
																<ListItem dense>
																	<ListItemIcon {...provided.dragHandleProps}>
																		<Tooltip title="Verschieben">
																			<DescriptionIcon />
																		</Tooltip>
																	</ListItemIcon>

																	<ListItemText
																		primary={
																			settings[`info_link_description_${index}`]?.value ||
																			settings[`info_link_url_${index}`]?.value
																		}
																		secondary={
																			settings[`info_link_description_${index}`]?.value
																				? settings[`info_link_url_${index}`]?.value
																				: ""
																		}
																	/>

																	<ListItemSecondaryAction>
																		<Tooltip title="Link löschen">
																			<IconButton
																				edge="end"
																				aria-label="löschen"
																				onClick={() => deleteLink(index)}
																			>
																				<DeleteIcon />
																			</IconButton>
																		</Tooltip>
																	</ListItemSecondaryAction>
																</ListItem>

																<Divider />
															</div>
														)}
													</Draggable>
												))}

												{provided.placeholder}
											</List>
										)}
									</Droppable>
								</DragDropContext>
						</>
					) : (
						<Typography>Noch keine Links hinzugefügt.</Typography>
					)}
				</Grid>

				{filledLinkIndexes.length > 0 ? (
					<Grid item xs={12}>
						<Button
							variant="contained"
							color="primary"
							size="small"
							startIcon={<SaveIcon />}
							onClick={saveAllInfoLinks}
						>
							Reihenfolge speichern
						</Button>
					</Grid>
				) : null}
				</Grid>
			</Grid>
		);
	};

	return (
		<div className={classes.root}>
			<div className={classes.actionButtons}>

			</div>
			<Typography variant="h2">Allgemeine Einstellungen</Typography>
			<Typography>Diese Einstellungen betreffen alle Benutzer und können nur von Administratoren geändert werden. <br />Wenn du nur die Einstellungen für deinen Account ändern möchtest findest du diese <NavLink to="/benutzereinstellungen/">hier</NavLink>.</Typography>
			<br />
			<Paper className={classes.settingsGroup}>
				Die Accounts zu den einzelnen Banken findest du jetzt in den <NavLink to="/benutzereinstellungen/">Benutzereinstellungen</NavLink>.
			</Paper>
			<Accordion className={classes.accordionGroup}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6">Aktuelle Top-Zinssätze</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={3} style={{ width: "100%" }}>
					{topRateFieldSettings.map((setting) => {
						return renderTopRateField(setting.key, setting.label, { xs: 12, sm: 6, md: 3 });
					})}
					<Grid item xs={12}>
						<TextField
							fullWidth
							multiline
							minRows={3}
							name="zins_comment"
							label="Anmerkung (für alle sichtbar)"
							value={settings.zins_comment.value ? settings.zins_comment.value : ""}
							onChange={(e) => {
								setSettings({
									...settings,
									[e.target.name]: { ...settings[e.target.name], value: e.target.value }
								})
							}}
							disabled={settings.zins_comment.status === "saving"}
						/>
					</Grid>
					{canViewAgentNotes(userContext.user.role) && (
						<Grid item xs={12}>
							{renderAgentNoteField("zins_agent_comment", "Anmerkung nur für Agenten")}
						</Grid>
					)}
					<Grid item xs={12}>
						<Button
							variant="contained"
							color="primary"
							size="small"
							onClick={() => {
								topRateSettingKeys.forEach(saveSetting);
							}}
							disabled={topRateSettingKeys
								.map((key) => settings[key]?.status)
								.includes("saving")}
							startIcon={<SaveIcon />}
						>
							speichern
						</Button>
					</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>

			<Accordion className={classes.accordionGroup}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6">Excel Vorlage für Hypothekarkredite</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={3} style={{ width: "100%" }}>
					<Grid item xs={6} md={6}>
						{/* Die Position der Felder bleibt gleich, es werden nur Felder umbenannt oder ausgeblendet */}
						{settings.excel_template.value ?
							<>
								<Typography>{settings.excel_template.value}</Typography>
								<Button
									size="small"
									color="primary"
									download target="_blank"
									href={`${process.env.REACT_APP_API_SERVICE_URL}/settings/fileuploads/excel_template/${settings.excel_template.value}?token=${userContext.accessToken}`}
									startIcon={<GetAppIcon size="small" />}
								>
									Download
								</Button>
								<InfoTooltip
									content={"Um Änderungen vorzunehmen kannst du die aktuelle Vorlage herunterladen, ändern und wieder hochladen."}
								/>
							</>
							:
							<Typography>Lade die Excel Vorlage hier hoch, die dann vom Channel Manager ausgefüllt wird.</Typography>
						}
					</Grid>
					<Grid item xs={6} md={3}>
						<DropzoneArea
							dropzoneClass={classes.dropzone}
							onDrop={(newFiles) => {
								if (Array.isArray(newFiles)) uploadFile(settings.excel_template, newFiles[0]);
								else uploadFile(settings.excel_template, newFiles);
							}}
							acceptedFiles={[
								"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
								"application/vnd.ms-excel",
							]}
							filesLimit={1}
							maxFileSize={20000000}
							showPreviewsInDropzone={false}
							showPreviews={false}
							useChipsForPreview={false}
							showFileNamesInPreview={false}
							showFileNames={false}
							dropzoneText={"Datei hier ablegen oder zum Auswählen klicken."}
							getFileLimitExceedMessage={(filesLimit) => {
								if (filesLimit === 1)
									return "Bitte lade hier nur eine Datei hoch.";

								return "Bitte lade maximal " + filesLimit + " Dateien hoch.";
							}}
							getFileAddedMessage={(fileName) => {
								return "Datei " + fileName + " wird geladen.";
							}}
							getFileRemovedMessage={(fileName) => {
								return "Datei " + fileName + " entfernt.";
							}}
							getDropRejectMessage={(
								rejectedFile,
								acceptedFiles,
								maxFileSize
							) => {
								var message =
									"Die Datei " +
									rejectedFile.name +
									" kann nicht verwendet werden. ";

								if (!acceptedFiles.includes(rejectedFile.type)) {
									message += "Es sind nur Excel Dateien möglich.";
								}

								if (rejectedFile.size > maxFileSize) {
									message +=
										"Die Datei ist zu groß. Es sind maximal  " +
										convertBytesToMbsOrKbs(maxFileSize) +
										" möglich.";
								}

								return message;
							}}
						/>
					</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>

			<Accordion className={classes.accordionGroup}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6">Excel Vorlage für Konsumkredite</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={3} style={{ width: "100%" }}>
					<Grid item xs={6} md={6}>
						{settings.excel_template_konsum.value ?
							<>
								<Typography>{settings.excel_template_konsum.value}</Typography>
								<Button
									size="small"
									color="primary"
									download target="_blank"
									href={`${process.env.REACT_APP_API_SERVICE_URL}/settings/fileuploads/excel_template_konsum/${settings.excel_template_konsum.value}?token=${userContext.accessToken}`}
									startIcon={<GetAppIcon size="small" />}
								>
									Download
								</Button>
								<InfoTooltip
									content={"Um Änderungen vorzunehmen kannst du die aktuelle Vorlage herunterladen, ändern und wieder hochladen."}
								/>
							</>
							:
							<Typography>Lade die Excel Vorlage hier hoch, die dann vom Channel Manager ausgefüllt wird.</Typography>
						}
					</Grid>
					<Grid item xs={6} md={3}>
						<DropzoneArea
							dropzoneClass={classes.dropzone}
							onDrop={(newFiles) => {
								if (Array.isArray(newFiles)) uploadFile(settings.excel_template_konsum, newFiles[0]);
								else uploadFile(settings.excel_template_konsum, newFiles);
							}}
							acceptedFiles={[
								"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
								"application/vnd.ms-excel",
							]}
							filesLimit={1}
							maxFileSize={20000000}
							showPreviewsInDropzone={false}
							showPreviews={false}
							useChipsForPreview={false}
							showFileNamesInPreview={false}
							showFileNames={false}
							dropzoneText={"Datei hier ablegen oder zum Auswählen klicken."}
							getFileLimitExceedMessage={(filesLimit) => {
								if (filesLimit === 1)
									return "Bitte lade hier nur eine Datei hoch.";

								return "Bitte lade maximal " + filesLimit + " Dateien hoch.";
							}}
							getFileAddedMessage={(fileName) => {
								return "Datei " + fileName + " wird geladen.";
							}}
							getFileRemovedMessage={(fileName) => {
								return "Datei " + fileName + " entfernt.";
							}}
							getDropRejectMessage={(
								rejectedFile,
								acceptedFiles,
								maxFileSize
							) => {
								var message =
									"Die Datei " +
									rejectedFile.name +
									" kann nicht verwendet werden. ";

								if (!acceptedFiles.includes(rejectedFile.type)) {
									message += "Es sind nur Excel Dateien möglich.";
								}

								if (rejectedFile.size > maxFileSize) {
									message +=
										"Die Datei ist zu groß. Es sind maximal  " +
										convertBytesToMbsOrKbs(maxFileSize) +
										" möglich.";
								}

								return message;
							}}
						/>
					</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
			<Accordion className={classes.accordionGroup}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6">SignoSign – Digitale Unterschriften</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={3} style={{ width: "100%" }}>
					<Grid item xs={6} md={4}>
						<TextField
							fullWidth
							type="text"
							name="signosign_user"
							value={settings.signosign_user.value ? settings.signosign_user.value : ""}
							// error={error !== null}
							// helperText={error}
							label="Benutzername"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value } })
							}}
							onBlur={() => {

							}}
							disabled={settings.signosign_user.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={4}>
						<TextField
							fullWidth
							type="password"
							name="signosign_password"
							value={settings.signosign_password.value ? settings.signosign_password.value : ""}
							// error={error !== null}
							// helperText={error}
							label="Passwort"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value } })
							}}
							disabled={settings.signosign_password.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={4}>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.signosign_user.status === "saving"
								|| settings.signosign_password.status === "saving"
							}
							onClick={() => {
								saveSetting("signosign_user");
								saveSetting("signosign_password");
							}}
							startIcon={<SaveIcon />}
						>
							speichern
						</Button>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.signosign_user.status === "saving"
								|| settings.signosign_password.status === "saving"
							}
							onClick={() => {
								checkSignatureCredentials()
							}}
							startIcon={<SettingsInputCompositeIcon />}
						>
							Verbindung prüfen
						</Button>
					</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
			<Accordion className={classes.accordionGroup}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6">Dokumentvorlagen zur Unterschrift</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={3} style={{ width: "100%" }}>
					{renderSignatureTemplateSettings()}

					</Grid>
				</AccordionDetails>
			</Accordion>

			<Accordion className={classes.accordionGroup}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6">Dokumente für Infobereich</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={3} style={{ width: "100%" }}>
						{renderDocumentInfoSettings()}
					</Grid>
				</AccordionDetails>
			</Accordion>

			<Accordion className={classes.accordionGroup}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6">Links für Infobereich</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={3} style={{ width: "100%" }}>
					{renderInfoLinksSettings()}
					</Grid>
				</AccordionDetails>
			</Accordion>

			<Accordion className={classes.accordionGroup}>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6">Liegenschaftscheckliste</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={3} style={{ width: "100%" }}>
					<Grid item xs={6} md={6}>
						{settings.liegenschaft_checklist.value ?
							<>
								<Typography>{settings.liegenschaft_checklist.value}</Typography>
								<Button
									size="small"
									color="primary"
									download target="_blank"
									href={`${process.env.REACT_APP_API_SERVICE_URL}/settings/fileuploads/liegenschaft_checklist/${settings.liegenschaft_checklist.value}?token=${userContext.accessToken}`}
									startIcon={<GetAppIcon size="small" />}
								>
									Download
								</Button>
								<InfoTooltip
									content={"Um Änderungen vorzunehmen kannst du die aktuelle Vorlage herunterladen, ändern und wieder hochladen."}
								/>
							</>
							:
							<Typography>Lade das PDF Formular hier hoch. Dieses kann dann vom Agenten pro Liegenschaft ausgefüllt und vom Kunden digital unterzeichnet werden.</Typography>
						}

					</Grid>
					<Grid item xs={6} md={3}>
						<DropzoneArea
							dropzoneClass={classes.dropzone}
							onDrop={(newFiles) => {
								if (Array.isArray(newFiles)) uploadFile(settings.liegenschaft_checklist, newFiles[0]);
								else uploadFile(settings.liegenschaft_checklist, newFiles);
							}}
							acceptedFiles={[
								"application/pdf",
							]}
							filesLimit={1}
							maxFileSize={20000000}
							showPreviewsInDropzone={false}
							showPreviews={false}
							useChipsForPreview={false}
							showFileNamesInPreview={false}
							showFileNames={false}
							dropzoneText={"Datei hier ablegen oder zum Auswählen klicken."}
							getFileLimitExceedMessage={(filesLimit) => {
								if (filesLimit === 1)
									return "Bitte lade hier nur eine Datei hoch.";

								return "Bitte lade maximal " + filesLimit + " Dateien hoch.";
							}}
							getFileAddedMessage={(fileName) => {
								return "Datei " + fileName + " wird geladen.";
							}}
							getFileRemovedMessage={(fileName) => {
								return "Datei " + fileName + " entfernt.";
							}}
							getDropRejectMessage={(
								rejectedFile,
								acceptedFiles,
								maxFileSize
							) => {
								var message =
									"Die Datei " +
									rejectedFile.name +
									" kann nicht verwendet werden. ";

								if (!acceptedFiles.includes(rejectedFile.type)) {
									message += "Es sind nur PDF Dateien möglich.";
								}

								if (rejectedFile.size > maxFileSize) {
									message +=
										"Die Datei ist zu groß. Es sind maximal  " +
										convertBytesToMbsOrKbs(maxFileSize) +
										" möglich.";
								}

								return message;
							}}
						/>
					</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
			<Paper className={classes.settingsGroup}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">Bank Austria</Typography>
					</Grid>
					<Grid item xs={6} md={4}>
						<TextField
							fullWidth
							type="password"
							name="bankaustria_api_key"
							value={settings.bankaustria_api_key.value ? settings.bankaustria_api_key.value : ""}
							// error={error !== null}
							// helperText={error}
							label="API Key"
							onChange={(e) => {
								setSettings({ ...settings, [e.target.name]: { ...settings[e.target.name], value: e.target.value } })
							}}
							onBlur={() => {

							}}
							disabled={settings.bankaustria_api_key.status === "saving"}
						/>
					</Grid>
					<Grid item xs={6} md={4}></Grid>
					<Grid item xs={6} md={4}>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.bankaustria_api_key.status === "saving"
							}
							onClick={() => {
								saveSetting("bankaustria_api_key");
							}}
							startIcon={<SaveIcon />}
						>
							speichern
						</Button>
						<Button
							variant="contained"
							color="primary"
							size="small"
							disabled={
								settings.bankaustria_api_key.status === "saving"
							}
							onClick={() => {
								checkBankaustriaCredentials()
							}}
							startIcon={<SettingsInputCompositeIcon />}
						>
							Verbindung prüfen
						</Button>
					</Grid>
				</Grid>
			</Paper>
		</div>
	);
}
